import './styles.css';

export default function MiddleButton({
  text,
  onClick,
  className = '',
  title,
  isLoading,
  dataTourId
}) {
  return (
    <div className="middle-button-wrapper" title={title}>
      <button
        className={`${className} ${isLoading ? 'loading' : ''}`}
        onClick={onClick}
        {...(dataTourId ? { 'data-tour-id': dataTourId } : {})}
      >
        {!isLoading && text}
      </button>
    </div>
  );
}
